import TextSource from './TextSource.js';
import { imageStore } from '../images.js';
import Sprite from '../ui/Sprite.js';
import { getOSM } from '../OverworldAnimation.js';

export default class HealingLocation extends TextSource {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            ...super.serialize(),
            position: this.position,
            preInteractionText: this.preInteractionText,
            postInteractionText: this.postInteractionText,
            // Don't serialize sprites - constructor will recreate them
        };
    }

    static deserialize(data) {
        return new HealingLocation({
            position: data.position,
            preInteractionText: data.preInteractionText,
            postInteractionText: data.postInteractionText,
        });
    }

    constructor({ text, position, OSM, GUI, preInteractionText, postInteractionText }) {
        super({ text, position, OSM, GUI });
        this.position = position;
        this.preInteractionText = preInteractionText;
        this.postInteractionText = postInteractionText;
        this.nurseScreen = new Sprite({
            image: imageStore.get('img/nurse_screen_animation.png'),
            visible: true,
            moving: false,
            frames: { max: 7, val: 4 },
            hold: 6,
        });
        this.visible = true;
        this.nurse = null;
        this.pokeball0 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });
        this.pokeball1 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });
        this.pokeball2 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });
        this.pokeball3 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });
        this.pokeball4 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });
        this.pokeball5 = new Sprite({
            image: imageStore.get('img/pokeball_to_be_cured.png'),
            position: {
                x: this.position.x - 32,
                y: this.position.y - 16,
            },
            visible: false,
            moving: false,
            frames: { max: 1, stopAtEnd: false },
        });

        this.healingPokeball = new Sprite({
            image: imageStore.get('img/pokeball_curing.png'),
            visible: false,
            moving: true,
            frames: { max: 4, stopAtEnd: false },
            hold: 8,
        });
    }

    effectiveX() {
        return this.position.x + this.xModifier;
    }

    effectiveY() {
        return this.position.y + this.yModifier;
    }

    effectivePosition() {
        if (this.OSM === null || this.OSM === undefined) {
            this.OSM = getOSM();
            return {
                x: 0,
                y: 0,
            };
        }
        return {
            x: this.position.x + this.OSM.GUI.playerXOffset,
            y: this.position.y + this.OSM.GUI.playerYOffset,
        };
    }

    drawPokeball0() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22;
        pokeballPosition.y -= 23;
        this.pokeball0.position = pokeballPosition;
        this.pokeball0.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball0.visible) {
            this.healingPokeball.draw();
        }
    }

    drawPokeball1() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22 - 6;
        pokeballPosition.y -= 23;
        this.pokeball1.position = pokeballPosition;
        this.pokeball1.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball1.visible) {
            this.healingPokeball.draw();
        }
    }

    drawPokeball2() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22;
        pokeballPosition.y -= 23 - 4;
        this.pokeball2.position = pokeballPosition;
        this.pokeball2.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball2.visible) {
            this.healingPokeball.draw();
        }
    }

    drawPokeball3() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22 - 6;
        pokeballPosition.y -= 23 - 4;
        this.pokeball3.position = pokeballPosition;
        this.pokeball3.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball3.visible) {
            this.healingPokeball.draw();
        }
    }

    drawPokeball4() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22;
        pokeballPosition.y -= 23 - 4 - 4;
        this.pokeball4.position = pokeballPosition;
        this.pokeball4.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball4.visible) {
            this.healingPokeball.draw();
        }
    }

    drawPokeball5() {
        const pokeballPosition = this.effectivePosition();
        pokeballPosition.x -= 22 - 6;
        pokeballPosition.y -= 23 - 4 - 4;
        this.pokeball5.position = pokeballPosition;
        this.pokeball5.draw();
        this.healingPokeball.position = pokeballPosition;
        if (this.pokeball5.visible) {
            this.healingPokeball.draw();
        }
    }

    drawNurseScreen() {
        this.nurseScreen.position = {
            x: this.effectivePosition().x + 3,
            y: this.effectivePosition().y - 39,
        };
        if (!this.nurseScreen.moving) {
            this.nurseScreen.frames.val = 6;
        }
        this.nurseScreen.draw();
    }

    showOnePokeball() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = false;
        this.pokeball2.visible = false;
        this.pokeball3.visible = false;
        this.pokeball4.visible = false;
        this.pokeball5.visible = false;
        this.healingPokeball.hold = 8;
    }

    showTwoPokeballs() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = true;
        this.pokeball2.visible = false;
        this.pokeball3.visible = false;
        this.pokeball4.visible = false;
        this.pokeball5.visible = false;
        this.healingPokeball.hold = 16;
    }

    showThreePokeballs() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = true;
        this.pokeball2.visible = true;
        this.pokeball3.visible = false;
        this.pokeball4.visible = false;
        this.pokeball5.visible = false;
        this.healingPokeball.hold = 24;
    }

    showFourPokeballs() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = true;
        this.pokeball2.visible = true;
        this.pokeball3.visible = true;
        this.pokeball4.visible = false;
        this.pokeball5.visible = false;
        this.healingPokeball.hold = 32;
    }

    showFivePokeballs() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = true;
        this.pokeball2.visible = true;
        this.pokeball3.visible = true;
        this.pokeball4.visible = true;
        this.pokeball5.visible = false;
        this.healingPokeball.hold = 40;
    }

    showSixPokeballs() {
        this.pokeball0.visible = true;
        this.pokeball1.visible = true;
        this.pokeball2.visible = true;
        this.pokeball3.visible = true;
        this.pokeball4.visible = true;
        this.pokeball5.visible = true;
        this.healingPokeball.hold = 48;
    }

    animatePokeballs() {
        this.healingPokeball.visible = true;
        this.healingPokeball.moving = true;
        this.nurseScreen.moving = true;
    }

    resetPokeballs() {
        this.resetPokeball(this.pokeball0);
        this.resetPokeball(this.pokeball1);
        this.resetPokeball(this.pokeball2);
        this.resetPokeball(this.pokeball3);
        this.resetPokeball(this.pokeball4);
        this.resetPokeball(this.pokeball5);
        this.healingPokeball.visible = false;
        this.healingPokeball.moving = false;
        this.healingPokeball.frames.val = 0;
        this.nurseScreen.frames.val = 6;
        this.nurseScreen.moving = false;
    }

    resetPokeball(pokeball) {
        pokeball.visible = false;
    }

    draw() {
        if (this.nurse === null && this.OSM.currentMap !== undefined) {
            const availableNurses = this.OSM.currentMap.npcs.filter((npc) => {
                return npc.type === 'nurse';
            });
            this.nurse = availableNurses[0];
        }
        this.drawNurseScreen();
        this.drawPokeball0();
        this.drawPokeball1();
        this.drawPokeball2();
        this.drawPokeball3();
        this.drawPokeball4();
        this.drawPokeball5();
    }
}
